const phones = [
  {
    id: 'tr',
    flag: '🇹🇷',
    country: 'Türkiye',
    number: '+90 532 237 65 76',
    href: 'tel:+905322376576',
    whatsapp: 'https://wa.me/905322376576',
    label: 'Ana İletişim Hattı',
    description: 'WhatsApp & Çağrı — Öncelikli Hat',
    primary: true,
  },
  {
    id: 'de1',
    flag: '🇩🇪',
    country: 'Almanya',
    number: '+49 177 595 87 62',
    href: 'tel:+491775958762',
    whatsapp: 'https://wa.me/491775958762',
    label: 'Almanya Hattı 1',
    description: 'Almanya Destek',
    primary: false,
  },
  {
    id: 'de2',
    flag: '🇩🇪',
    country: 'Almanya',
    number: '+49 162 243 76 27',
    href: 'tel:+491622437627',
    whatsapp: 'https://wa.me/491622437627',
    label: 'Almanya Hattı 2',
    description: 'Alternatif Hat',
    primary: false,
  },
];

export default function ContactCards() {
  return (
    <section className="bg-white py-16 md:py-20 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-brand-orange font-semibold text-xs uppercase tracking-[0.2em] mb-3">Hızlı İletişim</p>
          <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl">Bize Hemen Ulaşın</h2>
          <p className="text-gray-400 mt-3 text-sm max-w-md mx-auto">Türkiye veya Almanya'dan istediğiniz hattan bizi arayabilirsiniz</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {phones.map((phone) => (
            <div
              key={phone.id}
              className={`relative rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer bg-white ${
                phone.primary
                  ? 'border-2 border-brand-orange'
                  : 'border border-gray-150'
              }`}
              style={{ borderColor: phone.primary ? undefined : '#E8E8E8' }}
            >
              {/* Primary indicator — top accent bar instead of banner */}
              {phone.primary && (
                <div className="h-1 bg-brand-orange w-full"></div>
              )}

              <div className="p-6">
                {/* Country + label */}
                <div className="flex items-center justify-between mb-5">
                  <div className="flex items-center gap-3">
                    <span className="text-2xl">{phone.flag}</span>
                    <div>
                      <div className="text-xs text-gray-400 font-medium">{phone.country}</div>
                      <div className="text-brand-navy font-semibold text-sm">{phone.label}</div>
                    </div>
                  </div>
                  {phone.primary && (
                    <span className="text-xs font-semibold text-brand-orange border border-brand-orange/30 bg-brand-orange/5 px-2.5 py-1 rounded-full whitespace-nowrap">
                      Öncelikli
                    </span>
                  )}
                </div>

                <div className="font-heading font-bold text-xl text-brand-navy mb-1">
                  {phone.number}
                </div>
                <div className="text-gray-400 text-xs mb-5 leading-relaxed">{phone.description}</div>

                <div className="flex gap-2">
                  <a
                    href={phone.href}
                    className="flex-1 flex items-center justify-center gap-2 bg-brand-navy hover:bg-gray-800 text-white py-2.5 rounded-md text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-phone-fill text-sm"></i>
                    </span>
                    Ara
                  </a>
                  <a
                    href={phone.whatsapp}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="flex-1 flex items-center justify-center gap-2 bg-whatsapp hover:bg-whatsapp-dark text-white py-2.5 rounded-md text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-whatsapp-line text-sm"></i>
                    </span>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
